import { Grid } from '../../../../../Common/Grid'
import { Button, Input, Typography } from '@fullscreendigital/carrefour-dex-fe'
import { TitleHeader } from '../../../../Common/TitleHeader'
import { useLocation, useNavigate } from 'react-router-dom'
import { useQuery } from 'react-query'
import { makeCoreGetFileRequest } from "../../../../../../../utils/api"
import { formatErrorMessage } from '../../../../../../../utils/formatting'
import { useNotification } from '../../../../../../../hooks'
import { useRef } from 'react'
import { CircularProgress } from '@mui/material'
import { useReactToPrint } from 'react-to-print'
import { PDFPrintDocument } from 'components/core-ui/PDFPrintDocument'

const ReturnStep5 = () => {
  const { showNotification } = useNotification()
  const location = useLocation()
  const navigate = useNavigate()
  const componentRef = useRef(null)

  const id = location.state?.id
  const noticeSeries = location.state?.noticeSeries
  const noticeNumber = location.state?.noticeNumber

  const fetchPdfBlob = async () => {
    const res = await makeCoreGetFileRequest(
      `/shop-reception/ds-return-trucks/print/${id}`,
      { responseType: 'blob' }
    )

    const blob = (res instanceof Blob) ? res : res.data

    return new Blob([blob], { type: 'application/pdf' })
  }

  const { data: pdfBlob, isLoading: isLoadingPdf } = useQuery('pdfBlob', fetchPdfBlob, {
    onError: error => {
      showNotification({
        message: `Eroare la preluarea PDF-ului. ${formatErrorMessage(error)}`,
        type: 'error'
      })
    }
  })

  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  })

  if (isLoadingPdf) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  return (
    <Grid
      gridContainerStyle={{ marginTop: '20px' }}
      maxWidth="xs"
      items={[
        <TitleHeader title="COMANDǍ CAMION RETUR" />,
        <Typography variant="medium" component="p" style={{ textAlign: 'center' }}>
          A fost generat avizul!
        </Typography>,
        <Input
          type="text"
          label="Număr aviz"
          variant="outlined"
          width="100%"
          value={noticeNumber}
          readonly
        />,
        <Input
          type="text"
          label="Seria aviz"
          variant="outlined"
          width="100%"
          value={noticeSeries}
          readonly
        />,
        <Button
          type="button"
          variant="contained"
          label="PRINTEAZǍ"
          onClick={handlePrint}
          style={{ width: '100%' }}
          disabled={isLoadingPdf}
        />,
        <Button
          type="button"
          variant="contained"
          label="AM TERMINAT"
          onClick={() => navigate('/goodsReturn/suppliers')}
          style={{ width: '100%' }}
        />,
        <PDFPrintDocument pdfFile={pdfBlob} componentRef={componentRef} />
      ]}
      itemsPerRow={1}
    />
  )
}

export default ReturnStep5
